import { useState } from 'react';
import { F1, EmptyObject } from './types';

export const useUpdate = <T extends EmptyObject>(
  initial: T,
): [T, F1<Partial<T> | F1<T, Partial<T>>, null>] => {
  const [state, _setState] = useState(initial);
  const setState = (delta: Partial<T> | F1<T, Partial<T>>) => {
    _setState((prev) => ({
      ...prev,
      ...(typeof delta === 'function' ? delta(prev) : delta),
    }));
    return null;
  };
  return [state, setState];
};
